import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchBaseQuery } from './fetch-base-query';

/**
 * Helper function google sign in
 */
// function isSignupAllowed(allowList, email) {
//   if (
//     allowList.emails.includes(email) ||
//     allowList.domains.includes(email.split("@")[1])
//   ) {
//     return true;
//   }
//   return false;
// }

interface SignUpRequest {
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  job_title: string;
  organization: string;
}

interface InvitationSignUpRequest {
  firstName: string;
  lastName: string;
  password: string;
  email: string;
  code: string;
}

interface GenericResponse {
  message: string;
  type: string;
}

interface SendUserActivationRequest {
  code: string;
  activation_type: boolean;
}

interface SendResetEmailRequest {
  email: string;
}

interface SendCreatePasswordRequest {
  code: string;
  newPassword: string;
}

interface SendEmailVerificationRequest {
  code: string;
}

interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    // signInWithGoogle: builder.mutation<string, LoginRequest>({
    //   queryFn(arg, queryApi, extraOptions, baseQuery) {
    //     const firebase = getFirebase();
    //     firebase
    //       .auth()
    //       .signInWithPopup(provider)
    //       .then(async ({ user }) => {
    //         // Check if email is on allowlist
    //         try {
    //           const res = await baseFetch("/signupAllowlist");
    //           if (!res.ok) {
    //             return {
    //               error: {
    //                 status: 500,
    //                 statusText: 'Internal Server Error',
    //                 data: "Not allowed to sign in",
    //               },
    //             };
    //           }

    //           const allowlist = await res.json();
    //           if (!isSignupAllowed(allowlist, user.email)) {
    //             return {
    //               error: {
    //                 status: 500,
    //                 statusText: 'Internal Server Error',
    //                 data: "Email is not recognized by Fairly",
    //               },
    //             };
    //           }
    //           queryApi.dispatch(
    //             userProfileApi.endpoints.getProfile.initiate(undefined, {
    //               forceRefetch: true,
    //             })
    //           );
    //         } catch (err) {
    //           firebase.auth().signOut();
    //           const {message} = errorHandler(err);
    //           return {
    //             error: {
    //               status: 500,
    //               statusText: 'Internal Server Error',
    //               data: message,
    //             },
    //           };
    //         }
    //       })
    //     },
    //   },
    // }),

    signUp: builder.mutation<GenericResponse, SignUpRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append('user_email', data.email);
        formData.append('user_password', data.password);
        formData.append('first_name', data.firstname);
        formData.append('last_name', data.lastname);
        formData.append('organization', data.organization);
        formData.append('job_title', data.job_title);
        return {
          url: '/signup',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    invitationSignUp: builder.mutation<
      GenericResponse,
      InvitationSignUpRequest
    >({
      query: (newUser) => {
        const formData = new FormData();
        formData.append('firstName', newUser.firstName);
        formData.append('lastName', newUser.lastName);
        formData.append('password', newUser.password);
        formData.append('email', newUser.email);
        formData.append('code', newUser.code);
        return {
          url: '/invitationSignUp',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    sendUserActivation: builder.mutation<
      GenericResponse,
      SendUserActivationRequest
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('is_active_id', data.code);
        formData.append('activation_type', data.activation_type.toString());
        return {
          url: '/userAccountActivation',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    sendResetEmail: builder.mutation<GenericResponse, SendResetEmailRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append('email', data.email);
        return {
          url: '/forgotPassword',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    sendCreatePassword: builder.mutation<
      GenericResponse,
      SendCreatePasswordRequest
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('newpassword', data.newPassword);
        formData.append('resat_password_id', data.code ?? '');
        return {
          url: '/createNewPassword',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    sendEmailVerification: builder.mutation<
      GenericResponse,
      SendEmailVerificationRequest
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('email_verified_id', data.code);
        return {
          url: '/userEmailVerification',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">' + data.message + '</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
        }
      },
    }),

    changePassword: builder.mutation<GenericResponse, ChangePasswordRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append('currentPassword', data.currentPassword);
        formData.append('newPassword', data.newPassword);
        return {
          url: '/changePassword',
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});
